import React, { useState, useEffect } from "react";
import * as MUIStyled from "../../../MUIStyled";
import * as Styled from "../../../CompanyForm.styled";
import { ButtonText } from "../../elements/Buttons/Buttons.js";

export const DynamicReviewSection = ({
    title,
    tradingAddress,
    postalAddress,
    contactInfo,
    onEdit,
    areButtonsDisabled,
}) => {
    const [newContactInfo, setNewContactInfo] = useState([]);

    useEffect(() => {
        setNewContactInfo(contactInfo);
    }, [contactInfo]);

    // Contact type mapping
    const CONTACT_TYPES = {
        1: "Authorised Signatory",
        2: "Payroll",
        3: "Accounts",
        4: "HR",
    };

    // Function to generate contact type tags
    const renderContactTypeTags = (contact) => {
        const allTypes = new Set([
            ...(contact.primaryTypes || []),
            ...(contact.types || []),
        ]);

        if (allTypes.size === 0) return null;

        return Array.from(allTypes).map((typeId) => {
            const isPrimary = contact.primaryTypes?.includes(typeId);
            const typeName = CONTACT_TYPES[typeId] || `Type ${typeId}`;
            const label = isPrimary
                ? `Primary ${typeName}`
                : `Secondary ${typeName}`;

            return (
                <Styled.ContactTypeTag
                    key={typeId}
                    isPrimary={isPrimary}>
                    {label}
                </Styled.ContactTypeTag>
            );
        });
    };

    const renderAddress = () => {
        const formatAddress = (address) =>
            `${address.streetAddress}, ${address.subPremise && `${address.subPremise}, `} ${address.suburb} ${address.state} ${address.postcode}.`;

        return (
            <>
                <Styled.DynamicSectionInnerBox>
                    <Styled.BodyText
                        style={{
                            fontSize: "18px",
                            fontWeight: "600",
                            textAlign: "left",
                            lineHeight: "1",
                        }}>
                        Trading Address
                    </Styled.BodyText>
                    <Styled.BodyText
                        style={{
                            fontSize: "16px",
                            fontWeight: "400",
                            textAlign: "left",
                            lineHeight: "1",
                        }}>
                        {formatAddress(tradingAddress)}
                    </Styled.BodyText>
                </Styled.DynamicSectionInnerBox>
                <Styled.DynamicSectionInnerBox style={{ marginTop: "30px" }}>
                    <Styled.BodyText
                        style={{
                            fontSize: "18px",
                            fontWeight: "600",
                            textAlign: "left",
                            lineHeight: "1",
                        }}>
                        Postal Address
                    </Styled.BodyText>
                    <Styled.BodyText
                        style={{
                            fontSize: "16px",
                            fontWeight: "400",
                            textAlign: "left",
                            lineHeight: "1",
                        }}>
                        {formatAddress(postalAddress)}
                    </Styled.BodyText>
                </Styled.DynamicSectionInnerBox>
            </>
        );
    };

    const renderContact = () => {
        return (
            <>
                {newContactInfo && newContactInfo.length > 0 ? (
                    newContactInfo?.map((contact) => (
                        <Styled.DynamicSectionInnerBox
                            key={contact.id}
                            style={{ marginTop: "30px" }}>
                            <Styled.ContactNameTagsWrapper>
                                <Styled.BodyText
                                    style={{
                                        fontSize: "16px",
                                        fontWeight: "600",
                                        textAlign: "left",
                                        lineHeight: "1",
                                        margin: "0",
                                    }}>
                                    {contact.name} {contact.lastname}
                                </Styled.BodyText>
                                <Styled.ContactTagsContainer>
                                    {renderContactTypeTags(contact)}
                                </Styled.ContactTagsContainer>
                            </Styled.ContactNameTagsWrapper>

                            <Styled.BodyText
                                style={{
                                    fontSize: "16px",
                                    fontWeight: "400",
                                    textAlign: "left",
                                    lineHeight: "1",
                                }}>
                                {contact.phone?.trim()} - {contact.email}{" "}
                                {contact.title && `- ${contact.title}`}
                            </Styled.BodyText>
                        </Styled.DynamicSectionInnerBox>
                    ))
                ) : (
                    <Styled.BodyText>No contacts available.</Styled.BodyText>
                )}
            </>
        );
    };

    return (
        <Styled.DynamicMainWrapper style={{ margin: "0 0 30px 0" }}>
            {title && (
                <Styled.ReviewTitleBox style={{ margin: "0 0 30px 0" }}>
                    <Styled.DialogBoxTitle>{title}</Styled.DialogBoxTitle>
                    {!areButtonsDisabled && (
                        <ButtonText onClick={onEdit}>Edit</ButtonText>
                    )}
                </Styled.ReviewTitleBox>
            )}

            {tradingAddress && postalAddress && (
                <MUIStyled.CustomGrid
                    container
                    spacing={2}
                    direction="column">
                    <MUIStyled.CustomGrid
                        item
                        xs={12}
                        sm={6}>
                        <Styled.DynamicSectionMainBox>
                            {renderAddress()}
                        </Styled.DynamicSectionMainBox>
                    </MUIStyled.CustomGrid>
                </MUIStyled.CustomGrid>
            )}

            {newContactInfo && (
                <MUIStyled.CustomGrid
                    container
                    spacing={2}
                    direction="column">
                    <MUIStyled.CustomGrid
                        item
                        xs={12}
                        sm={6}>
                        <Styled.DynamicSectionMainBox>
                            {renderContact()}
                        </Styled.DynamicSectionMainBox>
                    </MUIStyled.CustomGrid>
                </MUIStyled.CustomGrid>
            )}
        </Styled.DynamicMainWrapper>
    );
};
